// import React from "react";
// import "./Common_Category_Swiper.css";
// import Common_Heading_Holder from "../common_heading_holder/Common_Heading_Holder";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Pagination } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/pagination";
// import Common_Category_Card from "../common_category_card/Common_Category_Card";

// const Common_Category_Swiper = ({ props, onItemClick }) => {
//   return (
//     <section className="Common_Category_Swiper">
//       <div className="card_heading_div">
//         <Common_Heading_Holder
//           headingText={props?.headingText}
//           viewShowAllButton={true}
//           goto="/all-products"
//         />
//       </div>

//       <div className="products_main_div">
//         <Swiper
//           spaceBetween={15}
//           pagination={{
//             dynamicBullets: true,
//             clickable: true,
//           }}
//           modules={[Pagination]}
//           autoplay={{ delay: 300 }}
//           className="common_swiper"
//           breakpoints={{
//             0: {
//               slidesPerView: 1.3,
//             },
//             350: {
//               slidesPerView: 2,
//             },
//             768: {
//               slidesPerView: 3.5,
//             },
//             992: {
//               slidesPerView: 3.2,
//             },
//             1200: {
//               slidesPerView: 4,
//             },
//             1400: {
//               slidesPerView: 5,
//             },
//           }}
//         >
//           {props?.data?.length > 0 &&
//             props?.data?.map((item) => {
//               return (
//                 <SwiperSlide>
//                   <Common_Category_Card
//                     prodImg={item?.image}
//                     prodName={item?.name}
//                     theme_colour={props?.theme_colour}
//                     goto="/shop"
//                   />
//                 </SwiperSlide>
//               );
//             })}
//         </Swiper>
//       </div>
//     </section>
//   );
// };

// export default Common_Category_Swiper;

import React from "react";
import "./Common_Category_Swiper.css";
import Common_Heading_Holder from "../common_heading_holder/Common_Heading_Holder";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import Common_Category_Card from "../common_category_card/Common_Category_Card";

const Common_Category_Swiper = ({
  data,
  headingText,
  theme_colour,
  button_colour,
  onItemClick,
}) => {
  return (
    <section className="Common_Category_Swiper">
      <div className="card_heading_div">
        <Common_Heading_Holder
          headingText={headingText}
          viewShowAllButton={true}
          goto={onItemClick}
        />
      </div>

      <div className="products_main_div">
        <Swiper
          spaceBetween={15}
          pagination={{
            dynamicBullets: true,
            clickable: true,
          }}
          modules={[Pagination]}
          className="common_swiper"
          breakpoints={{
            0: { slidesPerView: 1.3 },
            350: { slidesPerView: 2 },
            768: { slidesPerView: 3.5 },
            992: { slidesPerView: 3.2 },
            1200: { slidesPerView: 4 },
            1400: { slidesPerView: 5 },
          }}
        >
          {data?.length > 0 &&
            data?.map((item) => (
              <SwiperSlide key={item.id}>
                <div onClick={() => onItemClick && onItemClick(item)}>
                  <Common_Category_Card
                    prodImg={item?.image}
                    prodName={item?.name}
                    theme_colour={theme_colour}
                     button_colour={button_colour}
                    goto={null} // remove static navigation
                  />
                </div>
              </SwiperSlide>
            ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Common_Category_Swiper;
